exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-3b83e211] {\n  color: black;\n  text-decoration: underline; \n  font-weight: bold;\n}\n.style-success[data-v-3b83e211] {\n  color: #0099CC;\n  font-size: 100%;\n  font-weight: bold;\n}\n.style-error[data-v-3b83e211] {\n  color: #e3342f;\n  font-size: 100%;\n  font-weight: bold;\n}\n", ""]);

// exports
